import store from "../store"
import $ from 'jquery'
import PerfectScrollbar from 'perfect-scrollbar'

$(() => {
    'use strict'

    if (window.matchMedia('(max-width: 991px)').matches && store.state.user.type === "back-office") {
        const psNavbar = new PerfectScrollbar('#sidebarMenu', {
            suppressScrollX: true
        });
    }

    function showNavbarActiveSub() {
        if (window.matchMedia('(max-width: 991px)').matches) {
            $('#sidebarMenu .active').addClass('show');
        } else {
            $('#sidebarMenu .active').removeClass('show');
        }
    }

    showNavbarActiveSub()
    $(window).resize(function () {
        showNavbarActiveSub()
    })

    $('body').append('<div class="backdrop"></div>');


    $('.sidebar-menu .with-sub .nav-link').on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('show');
        $(this).parent().siblings().removeClass('show');

        if (window.matchMedia('(max-width: 991px)').matches) {
            psNavbar.update();
        }
    })


    $(document).on('click touchstart', function (e) {
        e.stopPropagation();

        if (window.matchMedia('(min-width: 992px)').matches) {
            var navTarg = $(e.target).closest('.sidebar-menu .nav-item').length;
            if (!navTarg) {
                $('.sidebar-header .show').removeClass('show');
            }
        }
    })

    $('#sidebarMenuClose').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('navbar-nav-show');
    });

    $('#sidebarMenuOpen').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('sidebar-show');
    })

    if ($('#sidebarMenu').length) {
        const psSidebar = new PerfectScrollbar('#sidebarMenu', {
            suppressScrollX: true
        });

        $('.sidebar-nav .with-sub').on('click', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('show');

            psSidebar.update();
        })
    }

    $('#sidebarMenuClose').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('sidebar-show');
    })

    function hideSidbar() {
        if ($('body').hasClass('navbar-nav-show')) {
            $('body').removeClass('navbar-nav-show');
        } else {
            $('body').removeClass('sidebar-show');
        }
    }

    $(document).on('click touchstart', function (e) {
        e.stopPropagation();

        if (!$(e.target).closest('.burger-menu').length) {
            var sb = $(e.target).closest('.sidebar').length;
            var nb = $(e.target).closest('.navbar-menu-wrapper').length;
            if (!sb && !nb) {
                hideSidbar();
            }

            $('.sidebar-nav li.nav-item nav a, .sidebar-nav li.nav-item a:not(.with-sub)').on('click', function (e) {
                hideSidbar();
            });
        }
    });
})
